module.exports = __webpack_public_path__ + "fonts/StagSans-Black.otf";


//////////////////
// WEBPACK FOOTER
// ./client/fonts/StagSans-Black.otf
// module id = 1096
// module chunks = 0